import {HTMLAttributes, ReactNode} from 'react';

interface PageProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const Page = ({children, ...rest}: PageProps) => {
  return <div {...rest}>{children}</div>;
};
